import { Stack } from '@chakra-ui/react'
import React, { useState } from 'react'

import { InputText } from '../styled'
import { FormContext, type FormInputType } from '../types'
import CharacterCount from './internal/CharacterCount'

const FormInputText: React.FC<{
  input: FormInputType & { type: 'text' }
}> = ({ input }) => {
  const { name: inputName, onChange: inputOnChange } = input
  const { submitting, onChange } = React.useContext(FormContext)
  const [length, setLength] = useState(input.initialValue?.length ?? 0)
  const handleInput = React.useCallback(
    (e: React.SyntheticEvent<HTMLInputElement>) => {
      const value = (e.target as HTMLInputElement).value.trim()
      onChange(inputName, value)
      inputOnChange?.(value)
      setLength(value.length)
    },
    [inputName, onChange, inputOnChange]
  )

  return (
    <Stack>
      <InputText
        name={input.name}
        placeholder={input.placeholder ?? ''}
        disabled={submitting || input.disabled}
        defaultValue={input.initialValue ?? ''}
        onInput={handleInput}
      />
      {input.minLength != null || input.maxLength != null ? (
        <CharacterCount min={input.minLength} max={input.maxLength} length={length} />
      ) : null}
    </Stack>
  )
}
export default FormInputText
